module.exports = __webpack_public_path__ + "fonts/righthand-extbolditalicdash-personal.a804717e.ttf";